export enum RegistrationStatus {
  UNAVAILABLE = 'unavailable',
  UNREGISTERED = 'unregistered',
  REGISTERED = 'registered',
  REFERRED = 'referred',
  SELECTED = 'selected',
  GRANTED = 'granted',
  SELECTED_NO_CLAIM = 'selected_no_claim',
}
export interface Survey {
  surveyId: string;
  response: object;
  createdAt: number;
  gameId: string;
}

export interface GameSurveys {
  dbd?: Survey[],
  mym?: Survey[],
}

export enum ReferralStatus {
  SENT = 'sent',
  ACCEPTED = 'accepted',
}
